import { gnosis } from 'viem/chains'
import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createGnosisChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createGnosisChainCustom({
    client: createClient({ chain: gnosis, httpRpcs: gnosisHttpRpcs }),
    explorer: createEtherscanV2({
      name: 'GnosisScan',
      baseUrl: 'https://gnosisscan.io',
      chainId: 100,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateGnosisChainCustomParameters = {
  client: Client
  explorer: Explorer
}

export const createGnosisChainCustom = ({
  client,
  explorer,
}: CreateGnosisChainCustomParameters): Chain => ({
  id: 100,
  network: 'gnosis',
  name: 'Gnosis',
  nativeToken: {
    name: 'Dai',
    symbol: 'DAI',
    decimals: 18,
    currency: {
      symbol: 'DAI',
      type: 'CryptoCurrency',
      id: 'dai',
      name: 'Dai',
      updatedAt: 0,
    },
  },
  wrappedTokenAddresses: new Set([
    '0xe91d153e0b41518a2ce8dd3d7944fa863463a97d',
  ]),
  explorer,
  client,
  blockTime: 5000,
  coingeckoId: 'xdai',
  defillamaId: undefined,
})

export const gnosisHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.gnosischain.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Not archive node
  // {
  //   url: 'https://gnosis-public.nodies.app',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://rpc.gnosis.gateway.fm',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Not archive node
  // {
  //   url: 'https://rpc.ap-southeast-1.gateway.fm/v4/gnosis/non-archival/mainnet',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://gnosis.api.onfinality.io/public',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  // Not archive node
  // {
  //   url: 'https://gnosis.drpc.org',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archive node
  // {
  //   url: 'https://endpoints.omniatech.io/v1/gnosis/mainnet/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archive node
  // {
  //   url: 'https://gnosis-rpc.publicnode.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://1rpc.io/gnosis',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://gno-mainnet.gateway.tatum.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Not archive node
  // {
  //   url: 'https://0xrpc.io/gno',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archive node
  // {
  //   url: 'https://gnosis.therpc.io',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://gnosis.oat.farm',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const gnosisWebsocketRpcUrls: string[] = [
  'wss://gnosis.drpc.org',
  'wss://gnosis-rpc.publicnode.com',
  'wss://0xrpc.io/gno',
]
